import type { VoidFunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router';
import Icon, { icons } from '../../generic/Icon';
import { trimString } from '../../../utils';
import { window } from '../../../globals';
import type { Organization } from '../../../types';
import * as IssuesV2Store from '../../../redux/issuesV2';
import TeamSelectionMenu from '../../shared/teams/TeamSelectionMenu';
import './GlobalIssuesSubnav.less';

/**
 * GlobalIssuesSubnav is essentially a clone and replacement of IssuesDashboardNav,
 * but connected to the issuesv2 store instead.
 * Dispatches the category fetch action when it mounts, then displays the counts
 * for each category next to the nav item.
 */
const GlobalIssuesSubnav: VoidFunctionComponent = () => {
  const dispatch = useDispatch();
  return (
    <nav>
      <Helmet title="Issues" />
      <h1 className="fossa-global-issues-header">
        <Link to="/projects">
          {trimString((window?.user?.organization as Organization)?.title ?? 'Organization', 13)}
        </Link>
        <span className="header-divider margin-left-xs margin-right-xs">
          <Icon icon={icons.angleRight} />
        </span>
        Issues
        <span className="header-divider margin-left-xs margin-right-xs">
          <Icon icon={icons.angleRight} />
        </span>
        <TeamSelectionMenu
          onChange={() => {
            dispatch(IssuesV2Store.actions.clearSelection());
            dispatch(IssuesV2Store.actions.preFetchLoading());
            dispatch(IssuesV2Store.actions.fetchIssues());
            dispatch(IssuesV2Store.actions.fetchStatusSummary());
          }}
        />
      </h1>
    </nav>
  );
};

export default GlobalIssuesSubnav;
